import React, { useEffect, useState } from 'react';
import "../styles/login.css";
import Layout from '../components/Layout/Layout';
import { toast, Toaster } from 'react-hot-toast'; // Importing toast for success/error messages
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Verify = () => {
  const navigate = useNavigate();
  const location = useLocation();




 // State for storing the form data
  const [formData, setFormData] = useState({
    emailOrPhone: '',
    OTP: '',
  });


  // Handle input changes and update state
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };



  useEffect(() => {
    const email1 = location?.state?.email;
    setFormData({
      ...formData,
      emailOrPhone: email1,
    });
  }, [location?.state?.email]);

  // Handle form submission
   



     // form function
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { emailOrPhone, OTP } = formData;

    // Basic validation before submitting
    if (!emailOrPhone || !OTP) {
      toast.error('Please fill in all fields');
      return;
    }
    try {
      const res = await axios.post(`${process.env.REACT_APP_MODE === 'development' ? "http://localhost:8000/api/v1" : `${process.env.REACT_APP_API_URL}`}/auth/otp-verification`, {
        email: emailOrPhone,
        otp: OTP,
      });
      if (res && res.data.success) {
        toast.success(res.data.message);
        toast.success("Redirecting to login page...");
        toast.success("Please login to continue");
        navigate("/login");
      } else{
        toast.error(res.data.message);
      }
    } catch (error) {
      // console.log(error.response.data.message);
      toast.error(error.response.data.message);
    }
  };
    












  return (
    <Layout title={"Lastbites: Verify"} children={undefined} description={undefined} keywords={undefined} author={undefined}>
      <main className="login">
        <div className="wrapper">
          <div className="title">
            <span>Veriy Your Email</span>
          </div>
            <div className="content" style={{textAlign: 'center', marginTop: '10px'}}>
                <p style={{color:"green"}} >Enter the OTP sent to your email</p>
            </div>

          <form onSubmit={handleSubmit}>
            <div className="row">
              <i className="fas fa-user" />
              <input
                type="text"
                placeholder="Email or Phone"
                name="emailOrPhone"
                value={formData.emailOrPhone}
                disabled = {true}
              />
            </div>
            <div className="row">
              <i className="fas fa-lock" />
              <input
                type="number"
                placeholder="Enter Your OTP"
                required
                name="OTP"
                value={formData.OTP}
                onChange={handleInputChange}
              />
            </div>
        
            <div className="row button">
              <input type="submit" value="Verify" />
            </div>
       
          </form>
        </div>
      </main>

      {/* Toast container for success/error messages */}
      <Toaster position="top-center" reverseOrder={false} />
    </Layout>
  )
}

export default Verify